@if (order$ | async; as order) {
  <div>
    @if (order.replenishmentOrderCode || order.sapOrderNumber) {
      <h2 class="cx-page-title">
        {{ 'checkoutOrderConfirmation.confirmationOfOrder' | cxTranslate }}
        {{
        (isReplenishmentOrderType$ | async)
        ? order.replenishmentOrderCode
        : order.sapOrderNumber
        }}
      </h2>
    } @else {
      <h2>
        {{ 'checkoutOrderConfirmation.confirmationOfConfiguratorOrder' | cxTranslate }}
      </h2>
    }
    @if (user$ | async; as user) {
      <div class="cx-order-confirmation-message">
        <p>
          {{ 'checkoutOrderConfirmation.invoiceHasBeenSentByEmail' | cxTranslate: {email: user.email} }}
          <a [routerLink]="{ cxRoute: ordersRoute } | cxUrl">{{ 'checkoutOrderConfirmation.orderHistory' | cxTranslate}}</a>
        </p>
      </div>
    }
  </div>
}
